import React from 'react';
import { _useAccountPaymentMethods } from '../hooks/useAccountPaymentMethods';
import { useBanner } from '../hooks/useBanner';
import { useMaintenance } from '../hooks/useMaintenance';
import { useGuestPay } from '../hooks/useGuestPay';

export interface BillingPortalStateType {
  bannerState: ReturnType<typeof useBanner>;
  maintenance: ReturnType<typeof useMaintenance>;
  accountPaymentMethods: ReturnType<typeof _useAccountPaymentMethods>;
  guestPayState: ReturnType<typeof useGuestPay>;
}

export const BillingPortalStateContext = React.createContext<BillingPortalStateType | undefined>(undefined);

export type BillingPortalStateProviderProviderProps = {
  children?: React.ReactNode | JSX.Element;
  userIsGuest?: boolean;
};

export const BillingPortalStateProvider = ({ children, userIsGuest }: BillingPortalStateProviderProviderProps) => {
  const bannerState = useBanner();
  const maintenance = useMaintenance({ userIsGuest });
  const accountPaymentMethods = _useAccountPaymentMethods();
  const guestPayState = useGuestPay();

  const appState = React.useMemo(() => {
    return { bannerState, maintenance, accountPaymentMethods, guestPayState };
  }, [bannerState, maintenance, accountPaymentMethods, guestPayState]);

  return <BillingPortalStateContext.Provider value={appState}>{children}</BillingPortalStateContext.Provider>;
};
